'use client'

import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/20/solid'

import { useLocale } from '@src/i18n/LocaleProvider'
import { cn } from '@src/utils/tailwind'

interface RailCarouselArrowsProps {
  arrowPosition: {
    vertical: number
  }
  previousSlide: (args: any) => void
  nextSlide: (args: any) => void
  hideLeft: boolean
  hideRight: boolean
}

export const RailCarouselArrows = ({
  arrowPosition,
  previousSlide,
  nextSlide,
  hideLeft,
  hideRight,
}: RailCarouselArrowsProps) => {
  const { t } = useLocale('carousel')
  const commonClasses = [
    '[--arrow-size:40px] lg:[--arrow-offset-x:6px] xl:[--arrow-offset-x:12px]',
    'flex items-center justify-center bg-white absolute z-10 flex size-(--arrow-size) shrink-0 rounded-full shadow-[0px_1px_3px_0px_#16181940] transition-all hover:bg-bodi-gray-pearl',
  ]

  if (arrowPosition.vertical === 0) return null

  const horizontalPosition = `calc(-1 * var(--arrow-size) - var(--arrow-offset-x))`

  return (
    <div className="hidden lg:block">
      <button
        onClick={previousSlide}
        aria-label={t('previous-slide')}
        className={cn(commonClasses)}
        style={{
          top: arrowPosition.vertical,
          left: horizontalPosition,
          opacity: hideLeft ? 0 : 1,
          visibility: hideLeft ? 'hidden' : 'visible',
        }}
      >
        <ChevronLeftIcon className="size-8 text-black" />
      </button>
      <button
        onClick={nextSlide}
        aria-label={t('next-slide')}
        className={cn(commonClasses)}
        style={{
          top: arrowPosition.vertical,
          right: horizontalPosition,
          opacity: hideRight ? 0 : 1,
          visibility: hideRight ? 'hidden' : 'visible',
        }}
      >
        <ChevronRightIcon className="size-8 text-black" />
      </button>
    </div>
  )
}
